import { useEffectOnce } from 'react-use';
import { AppSettingsGlobal } from '../../components/AppSettingsGlobal';
import { AppSettingsMain } from '../../components/AppSettingsMain';
import { AppSettingsScreen } from '../../components/AppSettingsScreen';
import { SettingsStages } from '../../models/Settings';
import {
	setActiveSettingsState,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { StyledContainer } from './PhoneSettings.styled';

const PhoneSettings = () => {
	const dispatch = useLayoutDispatch();
	const activeSettingsState = useLayoutSelector(
		(state) => state.settings.activeSettingsState,
	);

	useEffectOnce(() => {
		return () => {
			dispatch(setActiveSettingsState(SettingsStages.MAIN));
		};
	});

	return (
		<StyledContainer>
			{activeSettingsState === SettingsStages.MAIN && <AppSettingsMain />}
			{activeSettingsState === SettingsStages.GLOBAL && <AppSettingsGlobal />}
			{activeSettingsState === SettingsStages.SCREEN && <AppSettingsScreen />}
		</StyledContainer>
	);
};

export { PhoneSettings };
